<template>
    <div class="grid grid-cols-1 md:grid-flow-col auto-cols-fr rounded-md" role="tablist" aria-label="Result view tabs">
        <slot />
    </div>
</template>
